module.exports = __webpack_public_path__ + "static/media/first-aid-kit.3a153de5.svg";